export enum RecordKind {
  Spend = 'Spend',
  Income = 'Income',
  Refill = 'Refill',
}
